import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { mayaCepTemplateListRoute } from 'basics/constants/routes.constants';
import { useUpdateCepMutation } from 'basics/graphql/mutations/updateCep';
import useGetCepByIdQuery from 'basics/graphql/queries/getCepById';
import { warningToast } from 'basics/utils/toast';
import { CepFormSubmitCallbackType } from 'components/CepForm/CepForm.types';
import { useQueryParams } from 'hooks/useQueryParams';
import cepState from 'states/cep.states';

const useCepTemplateEdit = () => {
  const [updateCustomerEngagementPlanning] = useUpdateCepMutation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { id: cepId } = useQueryParams();

  const { data: customerEngagementPlanning, loading } = useGetCepByIdQuery(cepId || null);

  useEffect(() => {
    if (!loading) {
      if (customerEngagementPlanning) {
        cepState.cep = customerEngagementPlanning;
      } else {
        warningToast(t('errors_standard'));
        navigate(mayaCepTemplateListRoute);
      }
    }
  }, [customerEngagementPlanning, loading, navigate, t]);

  useEffect(() => {
    return function cleanup() {
      cepState.cep = {};
      cepState.tactics = [];
      cepState.targetList = [];
    };
  }, []);

  const submitCallback: CepFormSubmitCallbackType = async (cep) => {
    const customerEngagementPlanningData = await updateCustomerEngagementPlanning(
      cepId,
      cep,
      false,
    );

    return customerEngagementPlanningData;
  };

  return {
    customerEngagementPlanning,
    submitCallback,
  };
};

export default useCepTemplateEdit;
